import { useState } from "react";

/** Toggles password field visibility between plain text and masked. */
export const usePasswordVisibility = () => {
  const [showPass, setShowPass] = useState(false);
  const toggle = () => setShowPass((v) => !v);
  return { showPass, toggle };
};
